import { ACTIVITY_CALL_STATS } from "../constant/ActionType";

export default function GetCallStatsReportBy(
    state = {
        statscallactivitydata: [],
    },
    action
) {
    switch (action.type) {
        case ACTIVITY_CALL_STATS:
            return {
                ...state,
                statscallactivitydata: action.data,
            };
        default:
    }
    return state;
}
